<template>
  <div class="check">
    <a-drawer 
      :closable="false"
      :maskClosable="false"
      :destroyOnClose="true"
      placement="right"
      :title="$t('home.checkGroupTitle')"
      @close="onClose"
      :visible="visible" 
      >
      <div class="drawer-body">
        <div :style="{ borderBottom: '1px solid #E9E9E9' }">
          <a-checkbox
            :indeterminate="indeterminate"
            @change="onCheckAllChange"
            :checked="checkAll"
          >
            {{$t('home.checkAll')}}
          </a-checkbox>
        </div>
        <br />
        <a-checkbox-group :options="checkList" v-model="checkedList" @change="onChange" />
      </div>
      <div class="footer">
        <a-button class="btn" type="primary" @click="checkOk">{{$t('global.OK')}}</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
export default {
  props: {
    checkList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      visible: true,
      checkedList: this.checkList,
      indeterminate: false,
      checkAll: true
    }
  },
  methods: {
    onClose () {
      // console.log('close')
      this.visible = false
      this.$emit('checkOk', this.checkedList)
    },
    checkOk () {
      this.onClose()
    },
    onChange (checkedList) {
      // console.log(checkedList)
      this.indeterminate = !!checkedList.length && (checkedList.length < this.checkList.length)
      this.checkAll = checkedList.length === this.checkList.length
      // console.log(this.checkedList)
    },
    onCheckAllChange (e) {
      // console.log(e)
      let all = this.checkList
      Object.assign(this, {
        checkedList: e.target.checked ? all : [],
        indeterminate: false,
        checkAll: e.target.checked,
      })
      // console.log(this.checkedList)
    },
  }
}
</script>
<style lang="less" scoped>
// .check {
  .drawer-body {
    padding: 20px 0;
  }
  .footer {
    margin: 20px 0 0 0;
    .btn {
      width: 100%;
    }
  }
// }
</style>

